<template>
  <section
    :class="`planbook-vs-block ${toggleValue ? 'planbook-vs-block-show' : ''}`"
    :style="`
      ${borderCss}
      margin-left: ${leftMar}px;
      ${isFirst ? 'border-radius: 12px 0 0 0;' : ''}
      ${isLast ? `border-radius: 0 0 0 12px;border-bottom: ${borderColor || '#e5e5e5'} 1px solid;` : ''}
      ${isFirst && isLast ? 'border-radius: 12px 0 0 12px;' : ''}
    `"
  >
    <h1 class="planbook-vs-block-title" :style="`background: ${background}; ${borderCss}`">
      {{ title }}
    </h1>
    <div v-for="tableItem in list" class="pbf-vs-block-line" :style="borderCss">
      <div :style="`width: ${tableTitleWidth}px;${borderCss} background: ${background}`" class="pbf-vs-block-title">
        <p v-for="head in tableItem.heads">
          <span>{{ head }}</span>
        </p>
      </div>
      <div
        ref="scrollBox"
        class="pbf-vs-block-content"
        :style="`margin-left: ${tableTitleWidth}px;width: ${tdWidth * 2 + rightInMar}px;`"
        @scroll="onScroll"
      >
        <div
          class="pbf-vs-block-table"
          :style="`
            width: ${tdWidth * caseLength}px;
          `"
        >
          <div
            v-for="(Case, idx) in tableItem.htmls"
            class="pbf-vs-block-td"
            :style="`${borderCss}`"
          >
            <div
              v-if="typeof Case === 'object'"
              class="pbf-vs-block-td-inner"
              @click="onClick(Case)"
              v-html="Case.html"
            />
            <div v-else class="pbf-vs-block-td-inner" v-html="Case || '-'" />
            <img
              v-if="idx === caseLength - 1"
              ref="hideImg"
              src="https://res.winbaoxian.com/static/pbf/point.jpg"
              class="hide-img"
              @load="imgLoaded"
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="toggleShow" class="planbook-vs-toggle" @click="toggleValue = !toggleValue">
      <span>{{ toggleValue ? '收起' : '展开详情' }}</span>
      <i :class="`iconfont icon-arrows_${toggleValue ? 'up' : 'down'}`" />
    </div>
  </section>
</template>
<script>
export default {
  props: {
    name: String,
    // 模块标题
    title: String,
    // 模块左边屏幕边距
    leftMar: {
      type: Number,
      default: 12
    },
    // 模块滑动的距离
    left: {
      type: Number,
      default: 0
    },
    // 模块数据
    list: {
      type: Array,
      default: () => []
    },
    // 模块标题背景色
    background: {
      type: String,
      default: '#F5F8FE'
    },
    // 模块边框色
    borderColor: String,
    // 模块表格标题个数
    tableHeadLength: {
      type: Number,
      default: 1
    },
    // 模块表格标题宽度
    tableTitleWidth: {
      type: Number,
      default: 80
    },
    // 是否是组合里的第一个模块
    isFirst: Boolean,
    // 是否是组合里的最后一个模块
    isLast: Boolean
  },
  data() {
    return {
      // 单个险种表格宽度
      tdWidth: 0,
      move: 0,
      // 表格内容右边距离
      rightInMar: 20,
      // 是否显示展开详情按钮
      toggleValue: false
    }
  },
  computed: {
    caseLength() {
      if (!this.list.length) return 2
      return  (this.list[0].htmls || []).length
    },
    borderCss() {
      return this.borderColor ? `border-color: ${this.borderColor};` : ''
    },
    toggleShow() {
      const arr = this.list.filter(item =>
        item.htmls && item.htmls.find(cs => (typeof cs === 'string' && cs.indexOf('vs-description2') > -1) || (cs && cs.html && cs.html.indexOf('vs-description2') > -1))
      )
      return Boolean(arr.length)
    }
  },
  watch: {
    list: {
      handler(v) {
        if (!v || !v.length) return
        v.forEach(item => {
          if (!item.htmls || !item.htmls.length) return
          if (this.tableHeadLength) {
            item.heads = item.htmls.splice(0, this.tableHeadLength)
          }
        })
      },
      immediate: true
    },
    tableTitleWidth: {
      handler(v) {
        this.tdWidth = Math.ceil(window.innerWidth / 2 - this.leftMar / 2 - this.tableTitleWidth / 2 - this.rightInMar / 2)
      },
      immediate: true
    },
    left(v) {
      this.$refs.scrollBox.forEach(box => {
        box.scrollLeft = v
      })
    },
    toggleValue() {
      setTimeout(() => {
        this.$refs.hideImg.forEach(img => {
          this.imgLoaded(img)
        })
      })
    }
  },
  mounted() {
    this.parent = this.$parent
  },
  methods: {
    imgLoaded(ev) {
      const target = ev.tagName ? ev : ev.target
      const table = target.parentNode.parentNode
      table.parentNode.style.height = table.offsetHeight + 'px'
    },
    onClick(Case) {
      if (typeof Case.click === 'function') Case.click()
    },
    onScroll(ev) {
      this.parent.vsLeft = ev.target.scrollLeft
    }
  }
}
</script>
<style>
.planbook-vs-block {
  background: #fff;
  overflow: hidden;
  position: relative;
  border-top: #e5e5e5 1px solid;
  border-left: #e5e5e5 1px solid;
  .planbook-vs-block-title {
    padding: 0.2rem 0;
    text-align: center;
    color: #333;
    font-size: 0.3rem;
    border-bottom: #e5e5e5 1px solid;
  }
  .pbf-vs-block-line {
    position: relative;
    overflow: hidden;
    border-bottom: #e5e5e5 1px solid;
  }
  .pbf-vs-block-line:last-child {
    border: none
  }
  .pbf-vs-block-title {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    border-right: #e5e5e5 1px solid;
    z-index: 1;
    display: flex;
    p {
      flex: 1;
      height: 100%;
      text-align: center;
      border-right: #e5e5e5 1px solid;
      position: relative;
      span {
        position: absolute;
        width: 100%;
        left: 0;
        display: block;
        top: 50%;
        transform: translate(0, -50%)
      }
    }
    p:last-child {
      border-right: none
    }
  }
  .pbf-vs-block-content {
    overflow: hidden;
    overflow-x: scroll;
  }
  .pbf-vs-block-table {
    display: flex;
  }
  .pbf-vs-block-td {
    flex: 1;
    position: relative;
    border-right: #e5e5e5 1px solid;
    .hide-img {
      position: absolute;
      right: -1px;
      top: -1px;
    }
  }
  .pbf-vs-block-td-inner {
    margin: 12px;
    line-height: 20px;
    span {
      color: #ff5000;
      display: inline-block;
      margin-bottom: 5px;
    }
  }
  .vs-description2 {
    display: none
  }
  .planbook-vs-toggle {
    text-align: center;
    padding: 0.24rem 0;
    color: #666;
  }
}
.planbook-vs-block-show {
  .vs-description2 {
    display: block
  }
}
</style>